// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ec6075bb","487":"ac62c76b","724":"6f046ce8"}[chunkId] + ".chunk.js";
};